import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getMe } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }){
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function refreshMe(){
    try {
      const me = await getMe();
      setUser(me);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refreshMe();
  }, []);

  // Revalidate on tab focus and periodically to pick up remote role changes
  useEffect(() => {
    function onVis(){ if (document.visibilityState === 'visible') refreshMe(); }
    document.addEventListener('visibilitychange', onVis);
    let intervalId = setInterval(() => { if (!window.__hourslaw_timerActive) refreshMe(); }, 60000); // 60s refresh unless an active timer
    return () => { document.removeEventListener('visibilitychange', onVis); clearInterval(intervalId); };
  }, []);

  function setToken(token){
    if (token) localStorage.setItem('hourslaw.token', token); else localStorage.removeItem('hourslaw.token');
  }

  // Memoize the context value so child consumers don't re-render every time
  // AuthProvider itself re-renders for unrelated reasons.
  const value = useMemo(
    () => ({ user, setUser, loading, setToken }),
    [user, loading]
  );

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth(){
  return useContext(AuthCtx);
}